import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http, log} from 'hiya-common/src/utils/axios'

// 菜单列表接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=138986573
export const getMenusList = createAsyncThunk(
  '/live/hc/get_menus',
  async (arg, store: any) => {
    const resp = await http.post('/live/hc/get_menus', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
// 帮助中心分类 http://wiki.xunlei.cn/pages/viewpage.action?pageId=138986571
export const getCategoriesList = createAsyncThunk(
  '/live/hc/get_categories',
  async (arg, store: any) => {
    const resp = await http.post('/live/hc/get_categories', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
// 帮助中心文章列表 http://wiki.xunlei.cn/pages/viewpage.action?pageId=138986584
export const getQuestionList = createAsyncThunk(
  '/live/hc/get_posts',
  async (arg: any, store: any) => {
    const resp = await http.post('/live/hc/get_posts', {
      ...store.getState().env.deviceinfo,
      sort: 'default', // "time|default"
      limit: 10,
      top: 0,
      offset: 1,
      ...arg,
    })
    return resp.data.data
  }
)
// 获取问题详情
export const getQuestionDetail = createAsyncThunk(
  '/live/hc/get_post',
  async (arg: any, store: any) => {
    const resp = await http.post('/live/hc/get_post', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)
// [web通过mid获取用户信息] http://wiki.xunlei.cn/pages/viewpage.action?pageId=96438988
export const getMemberById = createAsyncThunk(
  '/live/account/simple_member_by_mid',
  async (arg, store: any) => {
    const resp = await http.post('/live/account/simple_member_by_mid', {
      ...store.getState().env.deviceinfo,
      mid: store.getState().env.deviceinfo.h_m,
    })
    return resp.data.data
  }
)
interface menus {
  id: string
  url: string
  icon: string
  title: string
}
interface categories {
  id: number
  icon: string
  title: string
}
interface question {
  id: string
  category_id: string
  top: boolean
  title: string
  content: string
  comment_num: number
  share_num: number // 分享数
  like_num: number // 点赞数
  unlike_num: number // 踩数
  createdAt: string
  updatedAt: string
}
interface memberInfoType {
  mid: number
  avatar_url: string
  name: string
}
interface InitialStateType {
  menusList: menus[]
  categoriesList: categories[]
  questionData: {
    total: number
    more: boolean
    list: question[]
  }
  questionDetail: any
  memberInfo: memberInfoType
}
const initialState: InitialStateType = {
  menusList: [],
  categoriesList: [],
  questionData: {
    total: 0,
    more: false,
    list: [],
  },
  questionDetail: {},
  memberInfo: {
    mid: null,
    avatar_url: '',
    name: '',
  },
}

export const HelpCenterSlice = createSlice({
  name: 'HelpCenter',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getMenusList.fulfilled, (state, action) => {
      Object.assign(state, {menusList: action.payload.list})
    })
    builder.addCase(getCategoriesList.fulfilled, (state, action) => {
      Object.assign(state, {categoriesList: action.payload.list})
    })
    builder.addCase(getQuestionList.fulfilled, (state, action) => {
      Object.assign(state, {questionData: action.payload})
    })
    builder.addCase(getQuestionDetail.fulfilled, (state, action) => {
      Object.assign(state, {questionDetail: action.payload})
    })
    builder.addCase(getMemberById.fulfilled, (state, action) => {
      Object.assign(state, {memberInfo: action.payload})
    })
  },
})

export default HelpCenterSlice.reducer
export const HelpCenterActions = HelpCenterSlice.actions
